"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _Link = _interopRequireDefault(require("../Link"));
var _index = _interopRequireDefault(require("./index.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DropdownMenu = props => {
  const {
    className = '',
    menuItems,
    id = 'MuiMenu',
    icon = /*#__PURE__*/_react.default.createElement(_KeyboardArrowDown.default, null),
    selectedIcon = /*#__PURE__*/_react.default.createElement(_Check.default, null),
    onSelectedOption = () => {},
    disabled = false,
    setSelectedOption = null,
    ...others
  } = props;
  const classes = (0, _index.default)();
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const [selected, setSelected] = (0, _react.useState)(menuItems[0].name);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    event.preventDefault();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const chosenOption = event => {
    const {
      option
    } = event.currentTarget.dataset;
    const selectedFoundOption = menuItems.find(selectedOoption => selectedOoption.name === option);
    const {
      key
    } = selectedFoundOption;
    setSelected(option);
    onSelectedOption({
      option,
      id,
      key
    });
    setAnchorEl(null);
  };
  (0, _react.useEffect)(() => {
    if (!setSelectedOption) {
      setSelected(menuItems[0].name);
    } else {
      setSelected(setSelectedOption.name);
    }
  }, [setSelectedOption, menuItems]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    key: id
  }, others, {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
    "data-testid": "search-menu",
    component: "button",
    underline: "none",
    disabled: disabled,
    "aria-controls": id,
    "aria-haspopup": "true",
    className: "".concat(classes.label),
    onClick: handleClick
  }, selected || menuItems[0].name, !disabled && icon)), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    className: "".concat(classes.root),
    "data-testid": "menu-".concat(id),
    id: id,
    anchorEl: anchorEl,
    keepMounted: true,
    MenuListProps: {
      'data-testid': 'menulist'
    },
    open: Boolean(anchorEl),
    onClose: handleClose
  }, menuItems && menuItems.map((option, i) => {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      "data-testid": "menu-option".concat(i)
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: "".concat(option.key, "-").concat(i),
      selected: option.name === selected,
      "data-option": option.name,
      onClick: event => chosenOption(event),
      disableTouchRipple: true
    }, option.name === selected ? selectedIcon : null, /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: "menuList"
    }, option.name));
  })));
};
var _default = exports.default = DropdownMenu;